export default {
  name: "Employer Obligations",
  prefix: "I/J",
  sections: [
    {
      name: "Public Disclosure Information",
      fields: [
        {
          isGroup: {
            code: "I.1",
            machine_name: "i1_disclosure_location",
            label:
              "Public disclosure information in the United States will be kept at: <br/><i>(You <u>must</u> select one or both of the options listed in this Section.)</i>",
            tooltip: `Indicate whether the employer’s required public disclosure information will be located at the employer’s principal place of business in the U.S. AND/OR the place of employment in the U.S. The employer may select more than one box. If the employer elects to store the public access file electronically, the employer must make the file available and accessible for government or public inspection upon request, at the particular location(s) provided in Section I of the Form ETA- 9035/9035E.`,
            coloring: "none",
            disabled: true,
            columns: false,
            required: true,
            fields: [
              {
                machine_name: "i1_is_disclosure_principal_business",
                widget: "checkbox_old",
                label: "Employer's principal place of business",
                choice: "Employer's principal place of business",
                hidden: true,
                value: "YES",
                validate: [
                  {
                    subsetOfSetRequired: "i1_is_disclosure_principal_business",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: ["i1_is_disclosure_principal_business", "i1_is_disclosure_place_of_employment"],
                    },
                  },
                ],
              },
              {
                machine_name: "i1_is_disclosure_place_of_employment",
                widget: "checkbox_old",
                hidden: true,
                choice: "Place of employment",
                label: "Place of employment",
                value: "YES",
                // validate: [
                //   {
                //     subsetOfSetRequired: "i1_is_disclosure_place_of_employment",
                //     message: "This field is required",
                //     needsFieldValues: true,
                //     extraData: {
                //       numRequired: 1,
                //       fieldArray: [
                //         "i1_is_disclosure_principal_business",
                //         "i1_is_disclosure_place_of_employment",
                //       ]
                //     }
                //   }
                // ]
              },
            ],
          },
        },
      ],
    },
    {
      name: "Notice of Obligations",
      fields: [
        {
          code: "A",
          label: `
              Upon receipt of the certified LCA, the employer must take the following actions: 
              Print and sign a hard copy of the LCA if filing electronically(20 CFR 655.705(c)(3));
              Maintain the original signed and certified LCA in the employer's files (20 CFR 655.705(c)(2)); 20 CFR 655.730(c)(3) ; and 20 CFR 655.760)
              Make a copy of the LCA, as well as necessary supporting documentation required by the Department of Labor regulations, available for public examination in a public access file at the employer's principal place of business in the U.s> or at the place of employment within one working day after the date on which the LCA is filed with the Department of Labor (20 CFR 655.705(c)(2) and 20 CFR 655.760).           
              `,
          inputType: "hidden",
        },
        {
          code: "B",
          inputType: "hidden",
          label: `
            <p> The employer must develop sufficient documentation to meet its burden of proof with respect to the validity of the statements made in its LCA and the accuracy of information provided, in the event that such statements or information is challenged (20 CFR 655.705(c)(5) and 20 CFR 655.700(d)(iv)).</p>
            `,
        },
        {
          code: "C",
          inputType: "hidden",
          label: `
            <p> The employer must make this LCA, supporting documentation, and other records available to officials of the Department of Labor upon request during any investigaion under the immigration and Nationality Act (20 CFR 655.760 and 20 CFR Subpart I).</p>
            `,
        },
        {
          inputType: "hidden",
          label: `
            <p><strong><i> I declare under penalty of perjury that I have read and reviewed this application and that to the best of my knowledge, the information contained therein is true and accurate.  I understand that to knowingly furnish materially false information in the preparation of this form and any supplemental thereto or to aid, abet, or counsel another to do so is a federal offense punishable fines, imprisonment, or both (18 U.S.C 2, 1001,1546,1621). </i></strong></p>
            `,
        },
      ],
    },
    {
      fields: [
        {
          code: "J.1",
          machine_name: "j1_official_last",
          widget: "text",
          label: "Last (family) name of hiring or designated official",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the last (family) name of the person with authority to sign as the employer.",
        },
        {
          code: "J.2",
          machine_name: "j2_official_first",
          widget: "text",
          label: "First (given) name of hiring or designated official",
          validate: [
            "required",
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the first (given) name of the person with authority to sign as the employer.",
        },
        {
          code: "J.3",
          machine_name: "j3_official_middle",
          widget: "text",
          label: "Middle Initial",
          maxLength: 3,
          tooltip: "Enter the middle name of the person with authority to sign as the employer, if applicable.",
        },
        {
          code: "J.4",
          machine_name: "j4_official_title",
          widget: "text",
          label: "Hiring or designated official title",
          validate: ["required"],
          maxLength: 60,
          tooltip: "Enter the job title of the person with authority to sign as the employer.",
        },
      ],
    },
  ],
};
